import { CustomConverter, JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { DateTimeConverter } from './converters/datesConverters';
import { ArticleLieuDepart } from '@/model/article-lieu-depart';
import { CodeDomaine } from '@/model/enum-types/code-domaine';
import { DestinatairesAlerte } from './alerte-notifications';

@JsonObject
export class Alerte {
  constructor (
    id?: number,
    domaine?: CodeDomaine,
    userName?: string,
    stockDispo?: boolean,
    prixMini?: number,
    prixMaxi?: number,
    echeanceMini?: Date,
    echeanceMaxi?: Date,
    actif?: boolean,
    articleLieuDepart?: ArticleLieuDepart,
    destinatairesAlerte?:DestinatairesAlerte[]
  ) {
    this.id = id as any;
    this.domaine = domaine as any;
    this.userName = userName as any;
    this.stockDispo = stockDispo as any;
    this.prixMini = prixMini as any;
    this.prixMaxi = prixMaxi as any;
    this.echeanceMini = echeanceMini as any;
    this.echeanceMaxi = echeanceMaxi as any;
    this.actif = actif as any;
    this.articleLieuDepart = (articleLieuDepart as any) || [];
    this.destinatairesAlerte = destinatairesAlerte || [];
  }

  @JsonProperty(Number)
  id: number;

  @JsonProperty(String)
  domaine: CodeDomaine;

  @JsonProperty(String)
  userName: string;

  @JsonProperty(Boolean)
  @Optional
  stockDispo: boolean;

  @JsonProperty(Number)
  @Optional
  prixMini: number;

  @JsonProperty(Number)
  @Optional
  prixMaxi: number;

  @JsonProperty(String)
  @Optional
  @CustomConverter(DateTimeConverter)
  echeanceMini: Date;

  @JsonProperty(String)
  @Optional
  @CustomConverter(DateTimeConverter)
  echeanceMaxi: Date;

  @JsonProperty(Boolean)
  @Optional
  actif: boolean;

  @JsonProperty([ArticleLieuDepart])
  articleLieuDepart?: ArticleLieuDepart[];

  @JsonProperty([DestinatairesAlerte])
  destinatairesAlerte?: DestinatairesAlerte[];
}
